<template>
  <span>
    <at-icon v-if="isEmail" class="file-type-email">  </at-icon>
    <email-outline-icon v-if="isEmailDocument || isOutlookDocument || isLetter"
                        class="file-type-email">  </email-outline-icon>
    <file-excel-icon v-if="isExcelDocument" class="file-type-excel">  </file-excel-icon>
    <file-icon v-if="!hasProps || isGenericFile" class="file-type-default"></file-icon>
    <file-image-icon v-if="isImageDocument" class="file-type-default"></file-image-icon>
    <file-pdf-icon v-if="isPDFDocument || isNote" class="file-type-pdf">    </file-pdf-icon>
    <file-word-icon v-if="isWordDocument" class="file-type-word">   </file-word-icon>
  </span>
</template>

<script>
import { IsAttachableTypeEnum } from '~/enums'

export default {
  name: 'FileTypeIconComponent',
  props: {
    filename: {
      type: String,
      required: false,
    },
    attachable: {
      type: Object,
      required: false,
    }
  },
  data () {
    return {
      pdfExtensions: ['pdf'],
      excelExtensions: ['xls', 'xlsx'],
      outlookExtensions: ['msg'],
      emailExtensions: ['eml'],
      imageExtensions: ['bmp', 'gif', 'jpeg', 'jpg', 'png'],
      wordExtensions: ['doc', 'docx']
    }
  },
  computed: {
    propIsFilename () {
      return this.filename !== null && typeof this.filename !== 'undefined'
    },
    propIsAttachable () {
      return this.attachable !== null && typeof this.attachable !== 'undefined'
    },
    hasProps () {
      // Giving one of both props is preferable. If none is given, a generic icon will be returned.
      return this.propIsAttachable || this.propIsFilename
    },
    extension () {
      if (this.propIsFilename) {
        return this.filename.substring(this.filename.lastIndexOf('.') + 1)
      } else if (this.isDocument) {
        return this.attachable.child_instance.data.extension
      } else {
        return ''
      }
    },
    isDocument () {
      return this.propIsAttachable && this.attachable.child_class === IsAttachableTypeEnum.DOCUMENT
    },
    isEmail () {
      return this.propIsAttachable && this.attachable.child_class === IsAttachableTypeEnum.EMAIL
    },
    isEmailDocument () {
      return this.emailExtensions.includes(this.extension)
    },
    isExcelDocument () {
      return this.excelExtensions.includes(this.extension)
    },
    isImageDocument () {
      return this.imageExtensions.includes(this.extension)
    },
    isLetter () {
      return this.propIsAttachable && this.attachable.child_class === IsAttachableTypeEnum.LETTER
    },
    isNote () {
      return this.propIsAttachable && this.attachable.child_class === IsAttachableTypeEnum.NOTE
    },
    isOutlookDocument () {
      return this.outlookExtensions.includes(this.extension)
    },
    isPDFDocument () {
      return this.pdfExtensions.includes(this.extension)
    },
    isWordDocument () {
      return this.wordExtensions.includes(this.extension)
    },
    isGenericFile () {
      return !this.isEmail
        && !this.isEmailDocument
        && !this.isExcelDocument
        && !this.isImageDocument
        && !this.isLetter
        && !this.isNote
        && !this.isOutlookDocument
        && !this.isPDFDocument
        && !this.isWordDocument
    },
  },
}
</script>

<style scoped>
.file-type-email {
  color: #0072C6;
}

.file-type-excel {
  color: #1D6F42;
}

.file-type-pdf {
  color: #F40F02;
}

.file-type-word {
  color: #00a2ed;
}

.file-type-default {
  color: #333333;
}
</style>